<template>
  <vs-popup :title="$t('CreateSaleTarget')" :active.sync="showModal">
    <div class="flex flex-col gap-2">
      <vs-input v-model="saleTarget.name" name="title" :label="$t('Title')" />

      <div class="flex flex-col">
        <label class="vs-select--label datepicker-lb">{{
          $t("StartDate")
        }}</label>
        <date-picker
          v-model="saleTarget.from"
          type="datetime"
          format="jYYYY-jMM-jDD HH:mm:ss"
          display-format="jYYYY-jMM-jDD HH:mm:ss"
          class="date-picker"
          :label="$t('StartDate')"
          name="startDate"
          v-validate="{ required: true }"
        />
        <span
          class="text-danger text-sm mt-1"
          v-show="errors.has('startDate')"
          >{{ errors.first("startDate") }}</span
        >
      </div>
      <div class="flex flex-col">
        <label class="vs-select--label datepicker-lb">{{
          $t("EndDate")
        }}</label>
        <date-picker
          v-model="saleTarget.to"
          type="datetime"
          format="jYYYY-jMM-jDD HH:mm:ss"
          display-format="jYYYY-jMM-jDD HH:mm:ss"
          class="date-picker"
          :label="$t('EndDate')"
          name="endDate"
          v-validate="{ required: true }"
        />
        <span class="text-danger text-sm mt-1" v-show="errors.has('endDate')">{{
          errors.first("endDate")
        }}</span>
      </div>

      <div class="flex justify-end my-6">
        <vs-button
          type="filled"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapActions } from "vuex";
import vSelect from "@/components/CustomVSelect.vue";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    startDate: {
      required: "لطفا تاریخ شروع را انتخاب نمایید.",
    },
    endDate: {
      required: "لطفا تاریخ پایان را انتخاب نمایید.",
    },
  },
};

Validator.localize("fa", dict);

export default {
  props: {
    show: { default: false },
  },
  watch: {
    show() {
      this.$validator.reset();
    },
  },
  components: { vSelect },
  data() {
    return {
      disabled: false,
      saleTarget: {
        name: "",
        from: "",
        to: "",
      },
      payload: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.resetForm();
      },
    },
  },
  methods: {
    ...mapActions({
      createSaleTarget: "saleTarget/createSaleTarget",
    }),
    acceptOnlyNumbersOnPrice(event) {
      let price = Number(event.replace(/\D/g, "")).toLocaleString();
      this.saleTarget.amount = price == 0 ? "" : price;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.payload = { ...this.saleTarget };
          this.createSaleTarget(this.payload).then(() => {
            this.resetForm();
            this.$emit("finish");
          });
        }
      });
    },
    resetForm() {
      this.saleTarget = {
        name: "",
        from: "",
        to: "",
      };
    },
  },
};
</script>
